import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { registerPWA } from './registerPWA';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

registerPWA();
